import { Link } from "react-router-dom";
import { brand } from "../config/brand";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      className={`brand ${compact ? "brand-compact" : ""}`}
      to="/"
      aria-label={`${brand.name} — inicio`}
    >
      <span className="brand-city-seal" aria-hidden="true">
        <img
          src="/brand/piribebuy-city-seal.webp"
          alt=""
          width="510"
          height="512"
          decoding="async"
        />
      </span>
      <span className="brand-wordmark" aria-hidden="true">
        <img
          className="brand-wordmark-light"
          src="/brand/piribebuy-digital-light.webp"
          alt=""
          width="1024"
          height="371"
          decoding="async"
        />
        <img
          className="brand-wordmark-dark"
          src="/brand/piribebuy-digital-dark.webp"
          alt=""
          width="1024"
          height="371"
          decoding="async"
        />
      </span>
    </Link>
  );
}

